import axios from "./axiosInstance";
import { USE_MOCK_API } from "../config/apiConfig";
import mockHomeAPI from "../mocks/services/mockHomeAPI";

const homePageAPI = {
  details: () => axios.get("details"),

  homePage: (payload) => axios.post("homepage", payload),

  fetchDetailsUsingSlug: (payload) =>
    axios.post("fetchDetailsUsingSlug", payload),

  fetchCategories: () => axios.post("homepage/category-for-navbar"),
};

// export default homePageAPI;
export default USE_MOCK_API
  ? mockHomeAPI
  : homePageAPI;
